<template>
  <section>
    <div class="accordion accordion-flush" id="accordion-feature">
      <div v-for="(category, idx) in categories" :key="idx" class="accordion-item">
        <div class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            :data-bs-target="`#accordion-feature-${idx}`" :aria-controls="`accordion-feature-${idx}`"
            aria-expanded="false">
            <span class="custom-category">{{ category }}</span>
          </button>
        </div>
        <div :id="`accordion-feature-${idx}`" class="accordion-collapse collapse" data-bs-parent="#accordion-feature">
          <div class="accordion-body">
            <ul class="custom-list">
              <li v-for="item in categoryItems(category)" :key="item.vehicleAdas">
                <span class="custom-item">{{ item }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'pinia'
import { buildStore } from '@/stores/build'
import globals from '@/plugins/globals'
export default {
  name: 'features',
  computed: {
    ...mapState(buildStore, ['build']),
    categories() {
      let _data = []
      if (this.build) {
        if (this.build.features) {
          let last = ''
          if (this.build.features["STANDARD"]) {
            this.build.features["STANDARD"].forEach(element => {
              if (last !== element.category) {
                _data.push(element.category)
              }
              last = element.category
            })
          }
        }
      }
      return _data
    }
  },
  methods: {
    toggleAccordion(idx) {
      let acc = document.getElementById(`accordion-feature-${idx}`)
      acc.classList.toggle('accordion-active')
      let accPanel = document.getElementById(`panel-feature-${idx}`)
      if (accPanel.style.maxHeight) {
        accPanel.style.maxHeight = null
      } else {
        accPanel.style.maxHeight = accPanel.scrollHeight + 'px'
      }
    },
    categoryItems(category) {
      let data = []
      let found = this.build.features["STANDARD"].filter(x => x.category === category)
      if (found) {
        found = globals.sortArray(found)
        found.forEach(element => {
          data.push(element.description)
        })
      }
      return data
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-accordion-tab {
  font-size: 1.1em;
  font-weight: 600;
}

.custom-list {
  list-style-type: none;

  li {
    padding: 5px;
  }

  li:hover {
    background-color: rgb(219, 219, 219);
    cursor: pointer;
  }
}

.custom-item {
  width: 100%;
}

.custom-category {
  font-weight: 500;
  font-size: 1.0em;
  font-style: italic;
}
</style>
